var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 19H16.6667C17.2855 19 17.879 18.7629 18.3166 18.341C18.7542 17.919 19 17.3467 19 16.75V7.75C19 7.35218 18.8361 6.97064 18.5444 6.68934C18.2527 6.40804 17.857 6.25 17.4444 6.25H15.8889V4.75C15.8889 4.55109 15.8069 4.36032 15.6611 4.21967C15.5152 4.07902 15.3174 4 15.1111 4C14.9048 4 14.707 4.07902 14.5611 4.21967C14.4153 4.36032 14.3333 4.55109 14.3333 4.75V6.25H9.66667V4.75C9.66667 4.55109 9.58472 4.36032 9.43886 4.21967C9.293 4.07902 9.09517 4 8.88889 4C8.68261 4 8.48478 4.07902 8.33892 4.21967C8.19306 4.36032 8.11111 4.55109 8.11111 4.75V6.25H6.55556C6.143 6.25 5.74733 6.40804 5.45561 6.68934C5.16389 6.97064 5 7.35218 5 7.75V16.75C5 17.3467 5.24583 17.919 5.68342 18.341C6.121 18.7629 6.71449 19 7.33333 19ZM6.55556 11.875C6.55556 11.7755 6.59653 11.6802 6.66946 11.6098C6.74239 11.5395 6.8413 11.5 6.94444 11.5H17.0556C17.1587 11.5 17.2576 11.5395 17.3305 11.6098C17.4035 11.6802 17.4444 11.7755 17.4444 11.875V16.75C17.4444 16.9489 17.3625 17.1397 17.2166 17.2803C17.0708 17.421 16.8729 17.5 16.6667 17.5H7.33333C7.12705 17.5 6.92922 17.421 6.78336 17.2803C6.6375 17.1397 6.55556 16.9489 6.55556 16.75V11.875Z",
    fill: "#3D3C7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.1ecc03372d18dc87e9e630ede90c35e8.svg";
export { ForwardRef as ReactComponent };